/* ─────────────────────────────────────────────────────────────────────────────
   GrowthOS migration — Email Marketing — RTK Query slice. Real
   GrowthOsContact.hs_email_* counters, synced live via the HubSpot token.
   ──────────────────────────────────────────────────────────────────────────── */
import { createApi } from '@reduxjs/toolkit/query/react'
import { apiConstants, get } from '../common/constants'

const EMAIL_MARKETING = apiConstants.GROWTHOS_ADMIN_EMAIL_MARKETING

const run = async (promise) => {
  try {
    const res = await promise
    return { data: res?.data }
  } catch (err) {
    const r = err?.response
    return {
      error: {
        status: r?.status,
        data: r?.data,
        message: r?.data?.message || err.message,
      },
    }
  }
}

// Drop undefined/empty params — `get` would otherwise send them as the literal "undefined".
const clean = (params) => Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''))

export const growthosEmailMarketingApiSlice = createApi({
  reducerPath: 'growthosEmailMarketingApi',
  baseQuery: () => ({ data: undefined }),
  tagTypes: ['EmailMarketing'],
  endpoints: (b) => ({
    getEmailMarketing: b.query({
      queryFn: ({ period, from, to } = {}) => run(get(EMAIL_MARKETING, clean({ period, from, to }))),
      providesTags: ['EmailMarketing'],
    }),
    // Reference GET /email-marketing/contacts — contact drill per metric / category / Sales POC.
    getEmailMarketingContacts: b.query({
      queryFn: ({ period, from, to, metric, category, leader } = {}) =>
        run(get(`${EMAIL_MARKETING}/contacts`, clean({ period, from, to, metric, category, leader }))),
      providesTags: ['EmailMarketing'],
    }),
    // Reference GET /email-marketing/companies — Companies KPI drill.
    getEmailMarketingCompanies: b.query({
      queryFn: ({ period, from, to } = {}) => run(get(`${EMAIL_MARKETING}/companies`, clean({ period, from, to }))),
      providesTags: ['EmailMarketing'],
    }),
  }),
})

export const {
  useGetEmailMarketingQuery,
  useGetEmailMarketingContactsQuery,
  useGetEmailMarketingCompaniesQuery,
} = growthosEmailMarketingApiSlice
